import { CircleX, Info, ChevronDown } from "lucide-react";
import { useState } from "react";
import { CalendarWithClock } from "./ui/CalendarWithClock";
/* import { CalendarWithClock } from "./ui/CalendarWithClock";
import { Card, CardContent } from "../components/ui/card"; */

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`fixed top-0 right-0 bg-sidebarbg font-sans font-semibold text-gray-400 p-5 transition-all duration-300 overflow-y-auto ${
        isOpen ? "w-[250px]" : " bg-transparent w-12"
      } h-screen flex flex-col justify-between`}
    >
      <div className="">
        <div className={`${isOpen ? "border-b-2 border-gray-700 mb-2" : ""}`}>
          {/* Toggle Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="absolute top-[192px] transform -translate-y-1/2 -translate-x-[19px] p-1 text-white bg-customOrange rounded-full  hover:bg-white hover:text-greenBg   transition-all duration-300 ease-in-out "
          >
            {isOpen ? (
              <CircleX size={18} color="#000000 " />
            ) : (
              <Info size={18} color="#000000" />
            )}
          </button>

          {/* Only Show CalendarWithClock if isOpen is true */} 

          {isOpen && (
            <div className="transition-opacity duration-300 ease-in-out mb-1 ">
              <CalendarWithClock />
            </div>
          )}
        </div>
        <div
          className={`${
            isOpen ? "border-gray-700 mb-2 text-white" : ""
          }`}
        >
          {isOpen && (
            <nav className="mb-2 ">
              <h2>Team Information</h2>
              <ul className="font-normal text-sm text-gray-200">
                <li className="flex items-center justify-between font-normal mb-1 ">
                  Dispatcher <ChevronDown size={15} />
                </li>
                <li className="flex items-center justify-between  font-normal mb-1 ">
                  Management <ChevronDown size={15} />
                </li>
                <li className="flex items-center justify-between  font-normal ">
                  Accountant
                  <ChevronDown size={15} />
                </li>
              </ul>
            </nav>
          )}
        </div>
      
        
      </div>
    </div>
  );
};

export default Sidebar;
